module.exports = __webpack_public_path__ + "static/img/Beni-Allen.a21ef89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Beni-Allen.jpg
// module id = v4/8
// module chunks = 0